import { render, staticRenderFns } from "./CheckoutSidebar.vue?vue&type=template&id=96eda85a&lang=pug&"
import script from "./CheckoutSidebar.vue?vue&type=script&lang=js&"
export * from "./CheckoutSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports